import FieldPermissionCrud from './FieldPermissionCrud'
export {FieldPermissionCrud}
export default FieldPermissionCrud
